<form [formGroup]="mediaSelectionDataFG" class="ui-g location-data-container component-container">
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <div class="margin-header-align text-uppercase page-title">{{ 'basic-profile.jurisdiction.page-title' | translate }}</div>
  </div>
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <app-section-header
      [title]="'basic-profile.jurisdiction.form-title' | translate"
      [tooltip]="'tooltips.jurisdiction.address-info' | translate"
      [showTooltip]="infoBubblesData?.showAddressInfo"></app-section-header>
  </div>

  <div class="ui-g form-section form-font-size">
    <div class="ui-g-6 margin-align">
      <label class="ui-g-4 field-label text-right-align required" for="float-input-steuer">
        {{ 'basic-profile.jurisdiction.postcode' | translate }}
      </label>
      <input
        [appNumber]="true"
        class="h4-button-and-field ui-input pInputText filed-width small-field-width"
        formControlName="postcode"
        id="float-input-steuer"
        pInputText
        size="30" />
    </div>

    <div class="ui-g-6 margin-align">
      <label class="ui-g-4 field-label text-right-align required" for="float-input-unternehmen">
        {{ 'basic-profile.fields.city' | translate }}
      </label>
      <input
        class="h4-button-and-field ui-input pInputText filed-width"
        formControlName="city"
        id="float-input-unternehmen"
        maxlength="100"
        pInputText
        size="30"
        type="text" />
    </div>

    <div class="ui-g-6 margin-align" *ngIf="mediaSelectionDataFG.get('district')">
      <label class="ui-g-4 field-label text-right-align" [class.required]="isDistrictRequired" for="float-input-strabe">
        {{ 'basic-profile.fields.district' | translate }}
      </label>
      <input
        class="h4-button-and-field ui-input pInputText filed-width"
        formControlName="district"
        id="float-input-strabe"
        maxlength="50"
        pInputText
        size="30"
        type="text" />
    </div>

    <div class="ui-g-6 margin-align">
      <label class="ui-g-4 field-label text-right-align required" for="float-input-hausenummer">
        {{ 'basic-profile.fields.street' | translate }}
      </label>
      <input
        class="h4-button-and-field ui-input pInputText filed-width"
        formControlName="street"
        id="float-input-hausenummer"
        maxlength="30"
        pInputText
        size="30"
        appAlpha="true" />
    </div>

    <div class="ui-g-6 margin-align">
      <label class="ui-g-4 field-label text-right-align required" for="float-input-plz">
        {{ 'basic-profile.fields.street_number' | translate }}
      </label>
      <input
        class="h4-button-and-field ui-input pInputText filed-width"
        formControlName="street_number"
        id="float-input-plz"
        maxlength="10"
        pInputText
        size="30"
        appStreetNumber="true" />
    </div>
  </div>

  <div
    *ngIf="
      currentInstallationFlow === installationFlowType.MainsConnection ||
      currentInstallationFlow === installationFlowType.TemporaryConnection
    "
    class="ui-g-12 form-section form-font-size">
    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
      <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
        <label class="ui-g-5"></label>
        <p-checkbox
          (onChange)="displayAreaName($event)"
          binary="true"
          class="checkbox-field"
          formControlName="newDevArea"
          id="new-development-area"
          label="{{ 'basic-profile.jurisdiction.new-development-area' | translate }}"></p-checkbox>
      </div>

      <div *ngIf="showAreaName" class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
        <label class="ui-g-5 field-label text-right-align required">
          {{ 'basic-profile.jurisdiction.development-area-name' | translate }}
        </label>
        <p-dropdown [options]="devAreaTypes" formControlName="devAreaName" id="water-heating-type" placeholder="-Select-">
          <ng-template let-item pTemplate="selectedItem">
            <span class="drop-item-label">{{ 'lookup.' + devAreaKey + '.options.' + item['value'] + '.name' | translate }}</span>
          </ng-template>
          <ng-template let-option pTemplate="item">
            <div class="drop-item">
              <span class="drop-item-label">{{ 'lookup.' + devAreaKey + '.options.' + option['value'] + '.name' | translate }}</span>
            </div>
          </ng-template>
        </p-dropdown>
      </div>
    </div>

    <div
      *ngIf="currentInstallationFlow === installationFlowType.MainsConnection"
      class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
      <!-- <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
        <label class="ui-g-5"></label>
        <p-checkbox binary="true"
                    class="checkbox-field"
                    formControlName="business"
                    id="business"
                    label="{{'basic-profile.jurisdiction.business' | translate}}"></p-checkbox>
      </div> -->
    </div>
    <div
      *ngIf="currentInstallationFlow === installationFlowType.MainsConnection && showAreaName"
      class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
      <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
        <label class="ui-g-5"></label>
        {{ 'basic-profile.jurisdiction.location-disclaimer' | translate }}
      </div>
    </div>
  </div>
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <app-section-header
      [title]="'basic-profile.jurisdiction.request' | translate"
      [tooltip]="'tooltips.jurisdiction.request' | translate"
      [showTooltip]="infoBubblesData?.showRequestInfo"></app-section-header>
  </div>

  <div *ngIf="currentInstallationFlow === installationFlowType.MainsConnection" class="ui-g-12 top-margin form-section form-font-size">
    <div class="ui-g-2 ui-xl-2 ui-lg-2 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
      <p-radioButton
        [(ngModel)]="selectedBuildingType"
        [value]="buildingTypes[0].value"
        formControlName="singleFamily"
        id="single-family-checkbox"
        label="{{ 'lookup.' + buildingTypeKey + '.options.' + buildingTypes[0].value + '.name' | translate }}"
        name="buildingTypeGroup"></p-radioButton>
    </div>

    <div class="ui-g-7 building-type-selectors" [class.reverse]="reverseBuildingTypes">
      <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding">
        <p-radioButton
          [(ngModel)]="selectedBuildingType"
          [value]="buildingTypes[1].value"
          formControlName="multiFamily"
          id="multi-family-checkbox"
          label="{{ 'lookup.' + buildingTypeKey + '.options.' + buildingTypes[1].value + '.name' | translate }}"
          name="buildingTypeGroup"></p-radioButton>
      </div>

      <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding">
        <p-radioButton
          [(ngModel)]="selectedBuildingType"
          [value]="buildingTypes[2].value"
          formControlName="apartmentHouse"
          id="apartment-house-1"
          label="{{ 'lookup.' + buildingTypeKey + '.options.' + buildingTypes[2].value + '.name' | translate }}"
          name="buildingTypeGroup"></p-radioButton>
      </div>
    </div>

    <div class="ui-g-2 ui-xl-2 ui-lg-2 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding">
      <p-radioButton
        [(ngModel)]="selectedBuildingType"
        [value]="buildingTypes[3].value"
        formControlName="apartmentHouse"
        id="apartment-house-2"
        label="{{ 'lookup.' + buildingTypeKey + '.options.' + buildingTypes[3].value + '.name' | translate }}"
        name="buildingTypeGroup"></p-radioButton>
    </div>
  </div>

  <div *ngIf="!isFeedSystem && !isChangeConnection && !isConversionToGas" class="ui-g-12 top-margin location-installation-section">
    <div class="ui-g-3 ui-xs-12 center_aligned" *ngIf="mediumVisibility.power">
      <span #checkboxElement (click)="selectMeter($event, 'power')" class="icon icon-electricity pointer-cursor" id="power"></span>
      <div class="icon-label">{{ 'overview.details-data.data-rows.power' | translate }}</div>
      <div class="meter-type-dropdown">
        <p-dropdown
          *ngIf="showDropdowns"
          [options]="installationChangeTypes"
          formControlName="powerType"
          id="jurisdiction-power-dropdown"
          placeholder="-Select-">
          <ng-template let-item pTemplate="selectedItem">
            <span class="drop-item-label">
              {{ 'lookup.' + installationChangeTypesKey + '.options.' + item['value'] + '.name' | translate }}
            </span>
          </ng-template>
          <ng-template let-option pTemplate="item">
            <div class="drop-item">
              <span class="drop-item-label">
                {{ 'lookup.' + installationChangeTypesKey + '.options.' + option['value'] + '.name' | translate }}
              </span>
            </div>
          </ng-template>
        </p-dropdown>
        <div class="align-marker" *ngIf="showDropdowns && mediaSelectionDataFG.value['power']">
          <label class="required"></label>
        </div>
      </div>
    </div>
    <div
      *ngIf="currentInstallationFlow !== installationFlowType.TemporaryConnection && mediumVisibility.gas"
      class="ui-g-3 ui-xs-12 center_aligned">
      <span #checkboxElement (click)="selectMeter($event, 'gas')" class="icon icon-gas pointer-cursor" id="gas"></span>
      <div class="icon-label">{{ 'overview.details-data.data-rows.gas' | translate }}</div>
      <div class="meter-type-dropdown">
        <p-dropdown
          *ngIf="showDropdowns"
          [options]="gasInstallationChangeTypes"
          formControlName="gasType"
          id="jurisdiction-gas-dropdown"
          placeholder="-Select-">
          <ng-template let-item pTemplate="selectedItem">
            <span class="drop-item-label">
              {{ 'lookup.' + gasInstallationChangeTypesKey + '.options.' + item['value'] + '.name' | translate }}
            </span>
          </ng-template>
          <ng-template let-option pTemplate="item">
            <div class="drop-item">
              <span class="drop-item-label">
                {{ 'lookup.' + gasInstallationChangeTypesKey + '.options.' + option['value'] + '.name' | translate }}
              </span>
            </div>
          </ng-template>
        </p-dropdown>
        <div class="align-marker" *ngIf="showDropdowns && mediaSelectionDataFG.value['gas']">
          <label class="required"></label>
        </div>
      </div>
    </div>
    <div class="ui-g-3 ui-xs-12 center_aligned" *ngIf="mediumVisibility.water">
      <span #checkboxElement (click)="selectMeter($event, 'water')" class="icon icon-water pointer-cursor" id="water"></span>
      <div class="icon-label">{{ 'overview.details-data.data-rows.water' | translate }}</div>
      <div class="meter-type-dropdown">
        <p-dropdown
          *ngIf="showDropdowns"
          [options]="waterInstallationChangeTypes"
          formControlName="waterType"
          id="jurisdiction-water-dropdown"
          placeholder="-Select-">
          <ng-template let-item pTemplate="selectedItem">
            <span class="drop-item-label">
              {{ 'lookup.' + waterInstallationChangeTypesKey + '.options.' + item['value'] + '.name' | translate }}
            </span>
          </ng-template>
          <ng-template let-option pTemplate="item">
            <div class="drop-item">
              <span class="drop-item-label">
                {{ 'lookup.' + waterInstallationChangeTypesKey + '.options.' + option['value'] + '.name' | translate }}
              </span>
            </div>
          </ng-template>
        </p-dropdown>
        <div class="align-marker" *ngIf="showDropdowns && mediaSelectionDataFG.value['water']">
          <label class="required"></label>
        </div>
      </div>
    </div>
    <div
      *ngIf="currentInstallationFlow !== installationFlowType.TemporaryConnection && mediumVisibility.heating"
      class="ui-g-3 ui-xs-12 center_aligned">
      <span #checkboxElement (click)="selectMeter($event, 'heating')" class="icon icon-geothermal pointer-cursor" id="heating"></span>
      <div class="icon-label">{{ 'overview.details-data.data-rows.heating' | translate }}</div>
      <div class="meter-type-dropdown">
        <p-dropdown
          *ngIf="showDropdowns"
          [options]="heatingInstallationChangeTypes"
          formControlName="heatingType"
          id="jurisdiction-heating-dropdown"
          placeholder="-Select-">
          <ng-template let-item pTemplate="selectedItem">
            <span class="drop-item-label">
              {{ 'lookup.' + heatingInstallationChangeTypesKey + '.options.' + item['value'] + '.name' | translate }}
            </span>
          </ng-template>
          <ng-template let-option pTemplate="item">
            <div class="drop-item">
              <span class="drop-item-label">
                {{ 'lookup.' + heatingInstallationChangeTypesKey + '.options.' + option['value'] + '.name' | translate }}
              </span>
            </div>
          </ng-template>
        </p-dropdown>
        <div class="align-marker" *ngIf="showDropdowns && mediaSelectionDataFG.value['heating']">
          <label class="required"></label>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="isFeedSystem" class="ui-g-12 top-margin location-installation-section">
    <div class="ui-g-4 ui-xs-12 center_aligned">
      <p-radioButton
        formControlName="construction-type"
        name="construction-type"
        [value]="feedInTypes[0].value"
        (onClick)="setFeedInInstType(feedInTypes[0].value)"></p-radioButton>
      <label class="field-label">{{ 'lookup.' + feedInTypeKey + '.options.' + feedInTypes[0].value + '.name' | translate }}</label>
    </div>
    <div class="ui-g-4 ui-xs-12 center_aligned">
      <p-radioButton
        formControlName="construction-type"
        name="construction-type"
        [value]="feedInTypes[1].value"
        (onClick)="setFeedInInstType(feedInTypes[1].value)"></p-radioButton>
      <label class="field-label">{{ 'lookup.' + feedInTypeKey + '.options.' + feedInTypes[1].value + '.name' | translate }}</label>
    </div>
    <div class="ui-g-4 ui-xs-12 center_aligned">
      <p-radioButton
        formControlName="construction-type"
        name="construction-type"
        [value]="feedInTypes[2].value"
        (onClick)="setFeedInInstType(feedInTypes[2].value)"></p-radioButton>
      <label class="field-label">{{ 'lookup.' + feedInTypeKey + '.options.' + feedInTypes[2].value + '.name' | translate }}</label>
    </div>
  </div>

  <div *ngIf="isChangeConnection" class="ui-g-12 top-margin location-installation-section">
    <div class="ui-g-4 ui-xs-12 center_aligned">
      <p-radioButton
        [(ngModel)]="selectedChangeType"
        [value]="changeRequestTypes[0].value"
        formControlName="connection-modification"
        name="connection-modification"></p-radioButton>
      <label class="field-label">{{ 'basic-profile.fields.close-connection' | translate }}</label>
    </div>
    <div class="ui-g-4 ui-xs-12 center_aligned">
      <p-radioButton
        [(ngModel)]="selectedChangeType"
        [value]="changeRequestTypes[1].value"
        formControlName="connection-modification"
        name="connection-modification"></p-radioButton>
      <label class="field-label">{{ 'basic-profile.fields.reinforce-connection' | translate }}</label>
    </div>
    <div class="ui-g-4 ui-xs-12 center_aligned">
      <p-radioButton
        [(ngModel)]="selectedChangeType"
        [value]="changeRequestTypes[2].value"
        formControlName="connection-modification"
        name="connection-modification"></p-radioButton>
      <label class="field-label">{{ 'basic-profile.fields.relocation-connection' | translate }}</label>
    </div>
  </div>

  <div *ngIf="isConversionToGas" class="ui-g-12 top-margin location-installation-section">
    <div class="ui-g-6 ui-xs-12 center_aligned">
      <p-radioButton
        [(ngModel)]="selectedChangeType"
        [value]="changeRequestTypes[3].value"
        formControlName="conversionTypeGas"
        name="conversion-type"></p-radioButton>
      <label class="field-label">{{ 'basic-profile.fields.on-gas' | translate }}</label>
    </div>
    <div class="ui-g-6 ui-xs-12 center_aligned">
      <p-radioButton
        [(ngModel)]="selectedChangeType"
        [value]="changeRequestTypes[4].value"
        formControlName="conversionTypeHeat"
        name="conversion-type"></p-radioButton>
      <label class="field-label">{{ 'basic-profile.fields.on-heating' | translate }}</label>
    </div>
  </div>

  <!-- NEW LSW FEATURE  -->
  <div *ngIf="isGridCompatibility" class="ui-g-12 top-margin location-installation-section">
    <div class="ui-g-4 ui-xs-12 center_aligned">
      <p-radioButton
        formControlName="area"
        name="area"
        [value]="feedInTypes[0].value"
        (onClick)="setFeedInInstType(feedInTypes[0].value)"></p-radioButton>
      <label class="field-label">{{ 'lookup.' + feedInTypeKey + '.options.' + feedInTypes[0].value + '.name' | translate }}</label>
    </div>
    <div class="ui-g-4 ui-xs-12 center_aligned">
      <p-radioButton
        formControlName="field"
        name="field"
        [value]="feedInTypes[1].value"
        (onClick)="setFeedInInstType(feedInTypes[1].value)"></p-radioButton>
      <label class="field-label">{{ 'lookup.' + feedInTypeKey + '.options.' + feedInTypes[1].value + '.name' | translate }}</label>
    </div>
    <div class="ui-g-4 ui-xs-12 center_aligned">
      <p-radioButton
        formControlName="field-sector"
        name="field-sector"
        [value]="feedInTypes[2].value"
        (onClick)="setFeedInInstType(feedInTypes[2].value)"></p-radioButton>
      <label class="field-label">{{ 'lookup.' + feedInTypeKey + '.options.' + feedInTypes[2].value + '.name' | translate }}</label>
    </div>
  </div>
  <!-- NEW LSW FEATURE  -->

  <div class="ui-g-12 submit-button-section text-center">
    <button
      (click)="submitFormData()"
      [disabled]="disableFormButtons || isLoading"
      class="submit-button"
      label="{{ 'basic-profile.jurisdiction.continue' | translate | uppercase }}"
      pButton></button>
  </div>

  <p-confirmDialog
    #confirmDialog
    icon="pi pi-info-circle"
    message="{{ 'basic-profile.jurisdiction.new-application-confirm-text' | translate }}"
    styleClass="netz-confirm-dialog">
    <p-footer>
      <button (click)="confirmDialog.accept()" label="{{ 'yes-button-label' | translate }}" pButton type="button"></button>
      <button (click)="confirmDialog.reject()" label="{{ 'no-button-label' | translate }}" pButton type="button"></button>
    </p-footer>
  </p-confirmDialog>
</form>
<app-loader *ngIf="isLoading"></app-loader>
